import { useMemo } from "react";
import { Reveal, Eyebrow } from "./Reveal";
import { ProductCard } from "./ProductCard";
import { COLLECTION_LABEL } from "@/lib/api";

const Pill = ({ active, children, ...rest }) => (
  <button {...rest}
    className={`rounded-full border px-4 py-2 text-sm transition-colors duration-300 ${active ? "border-[var(--ink)] bg-[var(--ink)] text-[var(--bone)]" : "border-[var(--line)] hover:border-[var(--ink)]"}`}>
    {children}
  </button>
);

export const Catalog = ({ products, collection, setCollection }) => {
  const list = useMemo(() => products.filter((p) => !collection || p.collection === collection), [products, collection]);

  return (
    <section id="catalogue" data-testid="product-catalog-grid" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-32">
      <Reveal className="mb-12 flex flex-col gap-8">
        <div>
          <Eyebrow>(02) — La sélection</Eyebrow>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight">
            {collection ? COLLECTION_LABEL[collection] : <>Nos <em className="italic text-[var(--terra)]">recommandations</em></>}
          </h2>
          <p className="mt-4 max-w-xl text-base text-[var(--muted)]">Chaque produit renvoie vers le site du marchand, qui affiche le prix à jour, la livraison et les avis clients.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Pill active={!collection} data-testid="filter-collection-all" onClick={() => setCollection(null)}>Tout</Pill>
          {Object.entries(COLLECTION_LABEL).map(([k, v]) => (
            <Pill key={k} active={collection === k} data-testid={`filter-collection-${k}`} onClick={() => setCollection(k)}>{v}</Pill>
          ))}
        </div>
      </Reveal>
      {list.length === 0 ? (
        <p data-testid="catalog-empty" className="py-20 text-center text-[var(--muted)]">Aucun produit dans cette catégorie.</p>
      ) : (
        <div className="grid grid-cols-1 gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
        </div>
      )}
    </section>
  );
};
